<template>
  <button class="last-used-card-wrapper" :data-external="dataExternal" @click="$emit('click')">
    <FriedSkeleton v-if="isLoading" class="resource-skeleton-thumb thumbnail" />
    <ResourceThumbnail
      v-else-if="isReady"
      class="thumbnail"
      :thumb-url="thumbUrl ?? '/assets/img/template-resource-placeholder.png'"
      :fallback-url="'/assets/img/template-resource-placeholder.png'"
    />
    <FriedH4 class="title-text">{{ label }}</FriedH4>
  </button>
</template>

<script lang="ts" setup>
import { useAsyncState } from '@vueuse/core';
import ResourceThumbnail from '../../content-library/components/ResourceThumbnail.vue';
import { DocumentService } from '../../api/documents/services/document.service';

const props = defineProps<{
  label: string;
  contentId: string;
  dataExternal: string;
}>();
defineEmits<{ click: [] }>();

const {
  state: thumbUrl,
  isLoading,
  isReady,
} = useAsyncState(DocumentService.loadDocumentPreviewImageUrl(props.contentId), null);
</script>

<style lang="scss" scoped>
.last-used-card-wrapper {
  box-shadow: var(--shadow-1);
  border-radius: var(--radius-medium);
  cursor: pointer;
  background: transparent;
  border: 0;
  display: grid;
  grid-template-rows: auto 1fr;
  align-items: center;
  gap: 0 var(--spacing-75);
  text-align: left;
  padding: 0;
  transition: box-shadow 0.2s ease-in-out;
  overflow: hidden;

  &:hover {
    box-shadow: var(--shadow-3);
  }

  .thumbnail {
    height: 100px;
  }

  .title-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: var(--spacing-100) var(--spacing-75) var(--spacing-75) var(--spacing-100);
  }
}
</style>
